import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Clock } from 'lucide-react';
interface PurchaseProps {
  checkoutUrl: string;
}
export function Purchase({
  checkoutUrl
}: PurchaseProps) {
  const includes = ['Manual académico completo de 1° a 6° año', 'Diapositivas listas para proyectar', 'Actividades dinámicas y juegos pedagógicos', 'Evaluaciones y trabajos prácticos desarrollados', 'Planificación y estructura profesional'];
  return <section id="compra" className="py-16 md:py-24 bg-[#1F3A5F] text-white" data-id="element-167">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-169">
          {/* Limited-time hint */}
          <div className="flex justify-center mb-6" data-id="element-170">
            <div className="inline-flex items-center gap-2 bg-[#D4A574]/15 border border-[#D4A574]/40 text-[#D4A574] px-4 py-2 rounded-full text-sm font-semibold tracking-wide uppercase" data-id="element-171">
              <Clock size={16} data-id="element-172" />
              Oferta por tiempo limitado
            </div>
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-center mb-4 font-oswald uppercase tracking-wide" data-id="element-173">
            💰 ACCEDÉ AL SISTEMA COMPLETO
          </h2>
          <p className="text-lg md:text-xl text-center mb-10 text-gray-300" data-id="element-174">
            Todo lo que necesitás para dar clases de Lengua y Literatura en
            secundaria, en un solo lugar.
          </p>

          {/* Offer card */}
          <div className="bg-white rounded-2xl p-8 md:p-10 shadow-2xl text-[#1F3A5F]" data-id="element-175">
            <p className="text-center text-sm md:text-base font-semibold uppercase tracking-wider text-gray-500 mb-3" data-id="element-176">
              Manual Académico — Lengua y Literatura
            </p>

            <div className="text-center mb-8" data-id="element-177">
              <span className="block text-5xl md:text-7xl font-bold text-[#1F3A5F] font-oswald tracking-wide" data-id="element-178">
                $19.990
              </span>
              <span className="block text-base md:text-lg text-gray-500 mt-1" data-id="element-179">
                ARS — pago único, acceso inmediato
              </span>
            </div>

            <ul className="space-y-3 mb-8 max-w-md mx-auto" data-id="element-180">
              {includes.map((item, idx) => <motion.li key={idx} initial={{
              opacity: 0,
              x: -15
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.35,
              delay: idx * 0.05
            }} className="flex items-start gap-3" data-id="element-181">
                  <CheckCircle2 className="text-[#2D6A4F] flex-shrink-0 mt-0.5" size={20} data-id="element-182" />
                  <span className="text-base md:text-lg text-gray-700" data-id="element-183">
                    {item}
                  </span>
                </motion.li>)}
            </ul>

            <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full bg-[#2D6A4F] hover:bg-[#1B4332] text-white text-lg md:text-2xl font-bold py-5 px-6 rounded-xl text-center transition-all transform hover:scale-[1.02] shadow-xl" data-id="element-184">
              QUIERO ACCEDER AHORA
            </a>

            <p className="text-center text-sm text-gray-500 mt-4 italic" data-id="element-185">
              El precio puede subir en cualquier momento.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}